module.exports = __webpack_public_path__ + "img/area-chart-spline-light-01.e9bfb99f.jpg";